let INSURANCE_PRODUCT_ID = null;
let PRICE = null;

async function getInsuranceData() {
  const request = await fetch(`/?sections=insurance-cart-details`);
  const response = await request.json();
  const section = response["insurance-cart-details"];
  const parser = new DOMParser();
  const html = parser.parseFromString(section, "text/html");
  const script = html.querySelector('script[type="application/json"]');
  const data = JSON.parse(script.textContent);

  if (data.variant) {
    INSURANCE_PRODUCT_ID = data.variant;
    PRICE = data.price;
  }

  return {
    phones_in_cart: data.phones_in_cart,
    insurance_in_cart: data.insurance_in_cart,
    shouldShowInsurance: data.phones_in_cart === 1,
  };
}

// The upsell markup (including the IPID and T&Cs modal) is fetched the first
// time the cart drawer needs it instead of being rendered into every page.
// Near-simultaneous opens share one request; a failed one resolves to null and
// is cleared so a later open can retry.
let insuranceTemplateRequest = null;

async function getInsuranceTemplate() {
  const template = document.querySelector("template#cart-insurance-template");
  if (template) return template;

  if (!insuranceTemplateRequest) {
    insuranceTemplateRequest = fetchInsuranceTemplate().finally(() => {
      insuranceTemplateRequest = null;
    });
  }
  return insuranceTemplateRequest;
}

async function fetchInsuranceTemplate() {
  try {
    const request = await fetch(`/?sections=cart-insurance-template`);
    if (!request.ok) return null;
    const response = await request.json();
    const html = response?.["cart-insurance-template"];
    if (typeof html !== "string" || !html.trim()) return null;
    document.body.insertAdjacentHTML("beforeend", html);
    return document.querySelector("template#cart-insurance-template");
  } catch (error) {
    console.error(error);
    return null;
  }
}

async function clearInsuranceFromCart() {
  const request = await fetch(
    `/cart/change.js?quantity=0&id=${INSURANCE_PRODUCT_ID}`
  );
  const response = await request.json();
}

async function processCart({
  shouldShowInsurance,
  phones_in_cart,
  insurance_in_cart,
} = {}) {
  if (!shouldShowInsurance || !phones_in_cart || !insurance_in_cart) {
    const insuranceData = await getInsuranceData();
    shouldShowInsurance = insuranceData.shouldShowInsurance;
    phones_in_cart = insuranceData.phones_in_cart;
    insurance_in_cart = insuranceData.insurance_in_cart;
  }

  // if (shouldShowInsurance) {
  const cartDrawer = document.querySelector(".hs-cart-drawer-0");
  if (!cartDrawer) return;
  // const insuranceUpsell = cartDrawer?.querySelector('cart-insurance-upsell');
  // if (insuranceUpsell) {
  //   insuranceUpsell.remove();
  // }
  const addDiscountButton = cartDrawer.querySelector(".hs-add-discount");
  const cartInsuranceTemplate = await getInsuranceTemplate();
  if (!cartInsuranceTemplate) return;
  const html = cartInsuranceTemplate.innerHTML;
  if (!cartDrawer.querySelector(".insurance-upsell")) {
    addDiscountButton.insertAdjacentHTML("beforebegin", html);
    const priceContainer = document.querySelector(
      ".hs-site-cart-popup-layout .insurance-upselll__price"
    );
    priceContainer.textContent = `£${PRICE} /mo`;

    // Set toggle state based on whether insurance is in cart
    const toggleBtn = cartDrawer.querySelector(".insurance-upsell__add-btn");
    if (insurance_in_cart && toggleBtn) {
      toggleBtn.classList.add("active");
    }
  }
  // }

  // if (!shouldShowInsurance) {
  //   const insuranceUpsell = document.querySelector('cart-insurance-upsell');
  //   if (insuranceUpsell) {
  //     insuranceUpsell.remove();
  //   }
  // }
}

class CartInsuranceUpsell extends HTMLElement {
  constructor() {
    super();
    this.productButton = this.querySelector(".insurance-upsell__add-btn");
    this.confirmationModal = this.querySelector(
      "#cart-insurance-confirmation-modal"
    );

    this.productButton.addEventListener("click", async () => {
      const { insurance_in_cart } = await getInsuranceData();

      if (!insurance_in_cart) {
        this.confirmationModal.showModal();
      } else {
        this.productButton.setAttribute("disabled", true);
        try {
          await clearInsuranceFromCart();
        } catch (error) {
          console.error(error);
        } finally {
          window.HS_SLIDE_CART_UPDATE(() => {
            this.productButton.removeAttribute("disabled");
            this.productButton.classList.remove("active");
          });
        }
      }
    });

    const modalCloseBtn = this.confirmationModal?.querySelector(
      ".insurance-modal-close"
    );
    modalCloseBtn?.addEventListener("click", () => {
      this.confirmationModal.close();
    });

    const cancelBtn = this.confirmationModal?.querySelector(
      ".insurance-modal-btn-cancel"
    );
    cancelBtn?.addEventListener("click", () => {
      this.confirmationModal.close();
      this.productButton.classList.remove("active");
    });

    const addBtn = this.confirmationModal?.querySelector(
      ".insurance-modal-btn-add"
    );
    addBtn?.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      addBtn.disabled = true;
      addBtn.classList.add("loading");
      addBtn.textContent = "";

      this.confirmationModal.close();

      this.productButton.setAttribute("disabled", true);
      try {
        await fetch(`/cart/add.js?quantity=1&id=${INSURANCE_PRODUCT_ID}`);
        this.productButton.classList.add("active");
      } catch (error) {
        console.error(error);
        this.productButton.classList.remove("active");
      } finally {
        window.HS_SLIDE_CART_UPDATE(() => {
          this.productButton.removeAttribute("disabled");
        });

        setTimeout(() => {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove("loading");
            addBtn.textContent = "Add to basket";
          }
        }, 1000);
      }
    });

    this.confirmationModal?.addEventListener("click", (e) => {
      if (e.target === this.confirmationModal) {
        this.confirmationModal.close();
      }
    });

    this.dialogButton = this.querySelector("[data-modal-trigger]");
    this.dialog = this.querySelector(".cart-insurance-dialog");

    this.dialogButton?.addEventListener("click", () => {
      this.dialog.showModal();
    });

    this.dialog?.addEventListener("cancel", () => {
      this.dialog.close();
    });

    this.dialog?.addEventListener("click", (e) => {
      if (e.target === this.dialog) {
        this.dialog.close();
      }
    });
  }
}

customElements.define("cart-insurance-upsell", CartInsuranceUpsell);

// async function handleCartDataUpdate() {
//   const { shouldShowInsurance, phones_in_cart, insurance_in_cart } = await getInsuranceData();
//   processCart({
//     shouldShowInsurance,
//     phones_in_cart,
//     insurance_in_cart,
//   });
// }

// function updateCartInsuranceClass() {
//   const isInsuranceInCart = !!document.querySelector(`.hs-product-${INSURANCE_PRODUCT_ID}`);

//   const cartContainer = document.querySelector('.hs-cart-drawer-0');
//   cartContainer?.classList.toggle('insurance-in-cart', isInsuranceInCart);
// }

// Using Slide Cart Drawer Events
// https://heysenior.com/helpdesk/slide-cart-drawer/dashboard/help-center
// updateCartInsuranceClass();
// window.HS_SLIDE_CART_LOADED = function (cart) {
//   updateCartInsuranceClass();

//   window.HS_SLIDE_CART_UPDATED = function (cart) {
//     if (cart?.items?.length !== 0) {
//       handleCartDataUpdate();
//     }
//     updateCartInsuranceClass();
//   };
// };
async function updateCartClassForInsurance() {
  const insuranceData = await getInsuranceData();
  insurance_in_cart = insuranceData.insurance_in_cart;
  shouldShowInsurance = insuranceData.shouldShowInsurance;
  phones_in_cart = insuranceData.phones_in_cart;
  insurance_in_cart = insuranceData.insurance_in_cart;

  if (insurance_in_cart || phones_in_cart == 0) {
    document
      .querySelector(".hs-cart-drawer-0")
      .classList.add("insurance-in-cart");
  } else {
    document
      .querySelector(".hs-cart-drawer-0")
      .classList.remove("insurance-in-cart");
  }
}
document.addEventListener("CUSTOM:HS_SLIDE_CART_UPDATED", async () => {
  updateCartClassForInsurance();
});
// using mutation observer to observe mutations in the cart node (hs-cart-drawer-0)
// when that exact node gets the class hs-active call processCart
// this is necessary because the HS_SLIDE_CART_OPENED is unreliable when automatic discounts
// are being applied

let isCartOpen = false;
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === "class") {
      const cartDrawer = document.querySelector(".hs-cart-drawer-0");
      if (cartDrawer?.classList.contains("hs-active")) {
        if (isCartOpen) return;

        processCart();
        isCartOpen = true;
      } else {
        isCartOpen = false;
      }
    }
  });
});

observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ["class"],
});
